<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 class="font-weight-bolder mb-0">Game</h4>
      </div>
    </b-col>

    <b-col cols="12">
      <b-row>
        <b-col cols="12">
          <b-card>
            <!-- Header -->
            <b-row>
              <b-col cols="12">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="font-weight-bold mb-0">Customer Eligibility</h5>
                  <div>
                    <input
                      ref="fileInput"
                      type="file"
                      accept=".csv"
                      hidden
                      @change="handleFileUpload"
                    />
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      @click="onClickInput"
                    >
                      <feather-icon icon="UploadIcon" />

                      CSV File Upload
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col cols="12">
                <div>
                  <div
                    class="d-flex align-items-center mb-1 cursor-pointer"
                    style="border-bottom: 1px solid #dee2e6"
                  >
                    <div
                      @click="activeTabCustomer = 'Customer Profiles'"
                      style="padding: 6px 16px"
                      :class="{
                        'active-tab': activeTabCustomer === 'Customer Profiles',
                      }"
                    >
                      Customer Profiles
                    </div>
                    <div
                      style="
                        padding: 6px 16px;
                        opacity: 0.45;
                        cursor: default;
                        user-select: none;
                      "
                      :class="{
                        'active-tab': activeTabCustomer === 'Customer Segments',
                      }"
                    >
                      Customer Segments
                    </div>
                  </div>

                  <b-row>
                    <b-col style="min-height: 100px">
                      <!-- Customer Profiles -->
                      <div
                        v-if="activeTabCustomer === 'Customer Profiles'"
                        class="grid-3"
                      >
                        <div
                          class="d-flex align-items-center cursor-pointer"
                          v-for="item in profiles"
                          :key="item"
                          style="
                            border: 1px solid #dee2e6;
                            border-radius: 5px;
                            gap: 10px;
                            padding: 8px 10px;
                          "
                          :style="{
                            background: selectedProfile.some((i) => i === item)
                              ? '#0D6EFD'
                              : '#f8f9fa',
                            color: selectedProfile.some((i) => i === item)
                              ? 'white'
                              : 'black',
                          }"
                          @click="handleSelectProfile(item)"
                        >
                          <div
                            class="d-flex justify-content-center align-items-center"
                            style="
                              width: 16px;
                              height: 16px;
                              border-radius: 2px;
                              border: 1px solid #dee2e6;
                            "
                            :style="{
                              background: selectedProfile.some(
                                (i) => i === item
                              )
                                ? '#0D6EFD'
                                : 'white',
                            }"
                          >
                            <feather-icon
                              icon="CheckIcon"
                              style="color: white"
                            />
                          </div>
                          {{ item }}
                        </div>
                      </div>

                      <!-- Customer Segments -->
                      <div
                        v-else
                        style="
                          opacity: 0.45;
                          pointer-events: none;
                          user-select: none;
                        "
                      >
                        <draggable
                          :list="customerSegments"
                          :group="{ name: 'tag', pull: 'clone', put: false }"
                          class="d-flex flex-wrap w-100"
                          :sort="false"
                        >
                          <b-col
                            v-for="(tag, index) in customerSegments"
                            :key="index"
                            cols="6"
                            md="3"
                            style="padding: 6px"
                          >
                            <b-card
                              border-variant="secondary"
                              body-class="p-0"
                              class="mb-0"
                              style="padding: 8px; border-radius: 4px"
                              :data-item="JSON.stringify(tag)"
                              ><span>{{ tag.name }}</span></b-card
                            >
                          </b-col>
                        </draggable>

                        <b-row>
                          <b-col
                            cols="12"
                            class="mt-1"
                            style="margin-bottom: 5px"
                          >
                            <small class="text-muted text-sm"
                              >Drag items to the table on the right to set
                              recurring issuance</small
                            ></b-col
                          >
                          <b-col>
                            <draggable
                              :value="selectedSegment"
                              @change="handleDrag"
                              @add="handleDrop"
                              group="tag"
                              class="w-100"
                            >
                              <div
                                style="
                                  border: 1px solid #dee2e6;
                                  border-radius: 5px;
                                "
                              >
                                <p
                                  style="
                                    background: #f8f9fa;
                                    font-weight: 800;
                                    border-radius: 5px 5px 0 0;
                                    padding: 8px 10px;
                                    border-bottom: 1px solid #dee2e6;
                                  "
                                >
                                  Segment
                                </p>

                                <div
                                  v-if="selectedSegment.length === 0"
                                  class="d-flex align-items-center justify-content-center"
                                  style="min-height: 100px"
                                >
                                  <div>
                                    Drag profiles or segments here to include in
                                    this promotion
                                  </div>
                                </div>
                                <div v-else>
                                  <div
                                    v-for="(item, ind) in selectedSegment"
                                    :key="ind"
                                    class="d-flex justify-content-between"
                                    style="
                                      border-bottom: 1px solid #dee2e6;
                                      padding: 6px 16px;
                                    "
                                  >
                                    <div class="d-flex flex-column">
                                      <span style="font-weight: 800">{{
                                        item.name
                                      }}</span>
                                      <span
                                        style="font-size: 12px"
                                        v-if="item.selectedUsers"
                                        >{{
                                          item.selectedUsers.length
                                        }}
                                        customers from CSV</span
                                      >
                                    </div>
                                    <b-button
                                      size="sm"
                                      variant="outline-danger"
                                      @click="deleteSegmentItem(item)"
                                      style="height: 29px !important"
                                    >
                                      Remove
                                    </b-button>
                                  </div>
                                </div>
                              </div>
                            </draggable>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col></b-row
            >
          </b-card>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12">
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          @click="$router.push('/promotions/game')"
          variant="outline-secondary"
          class="mr-1"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="handleSubmitPromotion"
          :disabled="loadingCreatePromotion"
        >
          <feather-icon icon="UploadIcon" /> Publish Promotion
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { formatDateSend } from "@/helpers/utils";
import useToastHandler from "@/services/toastHandler";
import {
  BButton,
  BCard,
  BCardBody,
  BCol,
  BContainer,
  BFormCheckbox,
  BRow,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import draggable from "vuedraggable";
import { v4 as uuidv4 } from "uuid";
import { parse } from "csv-parse";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BCardBody,
    BFormCheckbox,
    BContainer,
    draggable,
  },
  data() {
    return {
      profiles: [],
      customerSegments: [],
      selectedProfile: [],
      selectedSegment: [],
      activeTabCustomer: "Customer Profiles",
      form: {
        startTime: null,
        endTime: null,
        targets: null,
      },
    };
  },
  computed: {
    ...mapState("promotions/list", ["loadingCreatePromotion"]),
  },
  async created() {
    await Promise.all([this.fetchSegmentList(), this.fetchProfileList()]);
    const promotionId = this.$router.currentRoute.params.id;
    if (promotionId) this.fetchDetailPromotion();
  },
  methods: {
    ...mapActions({
      getSegmentsList: "segment/list/getSegmentsList",
      getProfileList: "user/list/getProfileList",
      createNewPromotion: "promotions/list/createNewPromotion",
      getDetailPromotion: "promotions/list/getDetailPromotion",
      updatePromotion: "promotions/list/updatePromotion",
      updatePromotionTargets: "promotions/list/updatePromotionTargets",
      deletePromotionTarget: "promotions/list/deletePromotionTarget",
      createUserList: "user/list/createUserList",
      getUserList: "user/list/getUserList",
      createNewUserGamePlay: "promotions/list/createNewUserGamePlay",
    }),
    async fetchSegmentList() {
      const { data } = await this.getSegmentsList({
        limit: 100,
      });
      this.customerSegments = data.map((i) => {
        return {
          name: i.name.trim(),
          id: i.id,
        };
      });
    },
    async fetchUserList(id) {
      const res = await this.getUserList(id);
      return res.data.map((i) => i.userId);
    },
    handleSelectProfile(item) {
      if (this.selectedProfile.some((i) => i === item))
        return (this.selectedProfile = this.selectedProfile.filter(
          (i) => i !== item
        ));
      this.selectedProfile = [...this.selectedProfile, item];
    },
    async fetchProfileList() {
      const data = await this.getProfileList();
      this.profiles = data.map((i) => i.profileTypeId);
    },
    async fetchDetailPromotion() {
      const promotionId = this.$router.currentRoute.params.id;
      if (!promotionId) return;
      const { data } = await this.getDetailPromotion(promotionId);
      this.form = {
        startTime: data.startTime,
        endTime: data.endTime,
        targets: data.targets,
      };
      const targets = data.targets.filter((i) => i.targetType !== "Profile");
      const selectedSegment = [];
      for (const i of targets) {
        if (i.targetType === "CustomerSegment") {
          const item = this.customerSegments.find((r) => r.id === i.targetId);
          if (item) selectedSegment.push(item);
          continue;
        }
        let list;
        if (i.targetType === "UserList") {
          list = await this.fetchUserList(i.targetId);
        }
        selectedSegment.push({
          id: i.targetId,
          ...i,
          name: "Untitled",
          selectedUsers: list,
        });
      }
      this.selectedSegment = selectedSegment;
      this.selectedProfile = this.form.targets
        .filter((i) => i.targetType === "Profile")
        .map((i) => {
          const item = this.profiles.find((r) => r === i.targetId);
          return item;
        });
    },
    deleteSegmentItem(item) {
      this.selectedSegment = this.selectedSegment.filter(
        (i) => i.id !== item.id
      );
    },
    async handleSubmitPromotion() {
      const promotionId = this.$router.currentRoute.params.id;
      const formatSelectedSegment = [];
      for (const i of this.selectedSegment) {
        if (!i.selectedUsers) {
          formatSelectedSegment.push({
            targetType: "CustomerSegment",
            targetId: i.id,
          });
          continue;
        }
        let targetUserListId;
        if (i && i.targetType === "UserList" && !i.targetId) {
          const resListId = await this.createUserList({
            userIds: i.selectedUsers,
          });
          if (resListId && resListId.data) targetUserListId = resListId.data;
        } else if (i.targetType === "UserList" && i.targetId) {
          targetUserListId = i.targetId;
        }
        formatSelectedSegment.push({
          targetType: "UserList",
          targetId: targetUserListId,
        });
      }
      const formatSelectedPosition = this.selectedProfile.map((i) => {
        return {
          targetType: "Profile",
          targetId: i,
        };
      });
      const promotionTargets = [
        ...formatSelectedPosition,
        ...formatSelectedSegment,
      ];
      const payload = {
        targets: [...formatSelectedPosition, ...formatSelectedSegment],
      };
      let res;
      if (!promotionId) {
        res = await this.createNewUserGamePlay(payload);
      } else {
        const [resPromo] = await Promise.all([
          this.updatePromotion({
            ...payload,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            promotionId,
          }),
          this.handleUpdatePromotionTargets(promotionTargets),
        ]);
        res = resPromo;
      }
      if (!res.data) return;
      this.showToastSuccess(
        "success",
        `Game Promotion ${promotionId ? "updated" : "created"} successfully!`
      );
      if (!promotionId) this.$router.push("/promotions/game");
    },
    convertListToIdsTarget(l) {
      return l.reduce((acc, item, index) => {
        const key = `ids[${index}]`;
        acc[key] = item.targetId;
        return acc;
      }, {});
    },
    async handleUpdatePromotionTargets(newTargets) {
      const promotionId = this.$router.currentRoute.params.id;
      const oldTargets = this.form.targets.map((t) => ({
        targetType: t.targetType,
        targetId: t.id,
      }));
      const isSame = (a, b) =>
        a.targetType === b.targetType && a.targetId === b.targetId;

      const targetsToDelete = oldTargets.filter(
        (oldT) => !newTargets.some((newT) => isSame(oldT, newT))
      );
      const targetsToAdd = newTargets.filter(
        (newT) => !oldTargets.some((oldT) => isSame(oldT, newT))
      );
      if (targetsToDelete.length) {
        await this.deletePromotionTarget(
          this.convertListToIdsTarget(targetsToDelete)
        );
      }
      if (targetsToAdd.length) {
        await this.updatePromotionTargets({
          promotionId,
          targets: targetsToAdd,
        });
      }
    },
    handleDrag(event) {},
    handleDrop(event) {
      const draggedTag = event.clone?.innerText?.trim();
      if (
        !draggedTag ||
        this.selectedSegment.some((i) => i.name === draggedTag)
      )
        return;
      const item = this.customerSegments.find((i) => i.name === draggedTag);
      this.selectedSegment.splice(event.newIndex, 0, {
        ...item,
      });
    },
    onClickInput() {
      const fileInput = this.$refs.fileInput;
      fileInput.click();
    },
    _resetInputFile() {
      this.$refs.fileInput.value = null;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.parseCSV(reader.result);
      };
      reader.readAsText(file);
      this._resetInputFile();
    },
    parseCSV(csvData) {
      parse(csvData, { delimiter: "," }, (err, data) => {
        if (err) {
          console.error(err);
          return;
        }
        data.shift();
        const newList = data.map((i) => i[0]);

        if (newList.length > 0) {
          this.selectedSegment = [
            ...this.selectedSegment,
            {
              name: "Untitled",
              id: uuidv4(),
              targetType: "UserList",
              selectedUsers: newList,
            },
          ];
          this.activeTabCustomer = "Customer Segments";
        }
      });
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();
    return {
      showToastSuccess,
      showToastError,
      formatDateSend,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

p {
  margin-bottom: 0;
}
</style>

<style lang="scss" scoped>
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.active-tab {
  color: #0d6efd;
  border: 1px solid #dee2e6;
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #0d6efd;
}

.active-position {
  background: #0d6efd;
  color: white;
}
</style>
